// extracted by mini-css-extract-plugin
export var pillContainer = "Pill-module--pill-container--2cd9d";